import React, { useState } from 'react';
import Form from 'olive-react-myoneui/lib/Form';
import Button from 'olive-react-myoneui/lib/Button';
import { closeIcon } from '../../../constants/icons';
import { useDispatch } from 'react-redux';
import { setContentFilterData, resetContentFilterData } from '../../../../reducers/contentFilterSlice';

const EventFilter = ({className, onClickFilterSlide}) => {
  const [selectedFilters, setSelectedFilters] = useState({
    itemType: [],
  });
  const filteredValue = {
    selectedFilters
  }
  const [isPrevFilterSelected, setIsPrevFilterSelected] = useState(false);
  
  const eventTypesOptions = [
    { id: 1, value: 'all', label: 'All' },
    { id: 2, value: 'online', label: 'Online Event' },
    { id: 3, value: 'offline', label: 'Offline Event' },
    { id: 4, value: 'blended', label: 'Blended Event' },
  ];


  const toggleCheckboxSelection = (group, value) => {
    setSelectedFilters(prevState => ({
      ...prevState,
      [group]: prevState[group].includes(value)
        ? prevState[group].filter(item => item !== value)
        : [...prevState[group], value],
    }));
    setIsPrevFilterSelected(true);
  };

  const dispatch = useDispatch();
  const handleApplyFilter = () => {
    dispatch(setContentFilterData(filteredValue));
    setIsPrevFilterSelected(Object.values(selectedFilters).some(arr => arr.length > 0));
  }

  const handleResetFilter = () => {
    dispatch(resetContentFilterData());
    setSelectedFilters({itemType: []})
    setIsPrevFilterSelected(false);
  }
  const isApplyButtonEnabled = isPrevFilterSelected ? true : Object.values(selectedFilters).some(arr => arr.length > 0) || false;

  return (
    <div className={`myk__stu-courses-filter-wrapper ${className || ''}`}>
        <div className="myk__stu-filter-header d-flex align-items-center justify-content-between gap-2">
            <h3>Event Type</h3>
            <span className="d-blok d-md-none p-2" role="button" onClick={onClickFilterSlide}>{closeIcon}</span>
        </div>
        {/* Enrollment Status Filter */}
        <div className="myk__stu-filter-inner-wrapper">
            <div className="myk__stu-filter-group">
                <div className="myk__stu-filter-inner">
                {eventTypesOptions.map(option => (
                    <Form.Check
                    key={option.value}
                    className="mb-2"
                    label={option.label}
                    inline
                    id={`${option.value}-events`}
                    onChange={() => toggleCheckboxSelection('itemType', option.value)}
                    checked={selectedFilters.itemType.includes(option.value)}
                    />
                ))}
                </div>
            </div>
        </div>
        {/* <div className="myk__stu-filter-actions d-flex align-items-center justify-content-end">
            <Button variant="outline" size="sm" className="d-block d-md-none px-4" onClick={onClickFilterSlide}>Close</Button>
        </div> */}
        {/* Filter Actions */}
        <div className="myk__stu-filter-actions d-flex align-items-center justify-content-end">
          <Button variant="default" className="" onClick={handleResetFilter}>Reset</Button>
          <Button variant="primary" className="" disabled={!isApplyButtonEnabled} onClick={handleApplyFilter}>Apply Filters</Button>
        </div>
    </div>  
    )
}

export default EventFilter;